import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Alert, Button, Panel } from 'react-bootstrap';
import { formatDate } from '../../shared/utils/date';

const ReceivedRunDetails = ({ isApplicable, openModal, receivedRun, removeReceivedRun }) => (
    <Panel collapsible expanded={isApplicable} header="Received run">
        <Alert bsStyle="info">
            Received run: only applicable to <strong>early and return freight</strong> abnormality!
        </Alert>
        {receivedRun && receivedRun.runId ? (
            <h5>
                <Link to={`/runs/${receivedRun.runId}`}>
                    <strong>Route code:</strong> {receivedRun.routeCode} -{' '}
                    <strong>Run sequence:</strong> {receivedRun.runSequence} -{' '}
                    <strong>Run date:</strong> {formatDate(receivedRun.runDate)}
                </Link>
            </h5>
        ) : null}
        <Button
            bsStyle="primary"
            style={{ marginTop: 15, marginRight: 15 }}
            onClick={isApplicable ? openModal : null}
        >
            Choose received run
        </Button>

        {receivedRun && receivedRun.runId ? (
            <Button bsStyle="default" style={{ marginTop: 15 }} onClick={removeReceivedRun}>
                Remove received run
            </Button>
        ) : null}
    </Panel>
);

ReceivedRunDetails.propTypes = {
    isApplicable: PropTypes.bool,
    openModal: PropTypes.func,
    removeReceivedRun: PropTypes.func,
};
ReceivedRunDetails.defaultProps = {
    isApplicable: false,
};

export default ReceivedRunDetails;
